<template>
	<div class="editEmployerClient">
		<!-- Main Body Content area -->
	    <div class="o-main-content-area">
	        <!-- Heading Section -->
	        <div class="row c-responsive-fixwidth">
	            <div class="col-md-6">
	                <h1 class="h1">Edit Employer</h1>
	            </div>
	            <div class="col-md-6 text-right">
	                <ul class="o-filter-area">
	                    <li><a @click="$router.go(-1)" href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a></li>
	                    <li v-if="!email_ckeck_flag"><a href="javascript: void(0)" @click="uploadService()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i> Save</a></li>
	                </ul>

	            </div>
	        </div>
	        <!-- /Heading Section -->
	    </div>
	    <div v-loading="loading" class="o-ndividualArea c-responsive-fixwidth">
	        <div class="o-ndividualTable employer-info">
	            <div class="field-group">
	                <div class="row">
	                  <div class="col-sm-12">
	                    <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3 c-user-tab-content clearfix o-skillset-area o-table-display">
	                      <div class="col-sm-3 o-table-cell-display">
	                        <div class="employerpic-upload-sec">
	                            <div class="employerpic-upload">
	                                <!-- <img v-if="employerDetails.image && employerDetails.image.length>0" :src="employerDetails.image" alt="" id='img-upload'>
	                                <img v-if="!employerDetails.image || employerDetails.image.length==0" src="static/assets/images/user1.png" alt="" id='img-upload'> -->
	                                <img
                                      :src="finalCropImg"
                                      alt="Cropped Image"
                                    />
	                            </div>
	                            <div class="employerpic-upload-btn o-upload-profile-btn">
                                 <div class="input-group">
                                     <span class="input-group-btn">
                                         <span class="btn btn-default btn-file">
                                             <input type="file" id="imgInp" @change="addProfileImg($event)">
                                         </span>
                                     </span>
                                     <input type="text" class="form-control" readonly>
                                 </div>
                                 <i class="fa fa-plus"></i>
                             	</div>
	                        </div>
	                      </div>
	                      <div class="col-sm-9 no_padding o-table-cell-display">
	                        <p>Basic Info:</p>
	                        <div class="row">
	                            <div class="col-sm-12">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Company Name:<sup>*</sup></label>
	                                    <input v-model="employer.company_name" v-validate="'required'" name="company name" type="text" class="form-control" placeholder="Name">
	                                   <span class="err-msg">{{ errors.first('company name') }}</span>
	                                </div>
	                            </div>
	                            <!-- <div class="col-sm-6">
	                            	<div class="form-group ">
	                                    <label class="common-label-text">Company Email:</label>
	                                    <input v-model="employer.company_email" name="company email" type="email" class="form-control" placeholder="Email">
	                                </div>
	                            </div> -->
	                        </div>
	                        <p>Admin User (Free):</p>
	                        <div class="row">
	                            <div class="col-sm-8">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Contact Person Name:<sup>*</sup></label>
	                                    <input v-model="employer.name" v-validate="'required'" name="Contact Person" type="text" class="form-control" placeholder="Name">
	                                    <span class="err-msg">{{ errors.first('Contact Person') }}</span>
	                                </div>
	                            </div>
	                            <!-- <div class="col-sm-4">
	                                <div class="form-group ">
	                                    <label class="common-label-text">Nickname:</label>
	                                    <input v-model="employer.nick_name" name="nickname" type="text" class="form-control" placeholder="Nickname">
	                                </div>
	                            </div> -->
	                            <div class="col-sm-4">
	                                <div class="form-group ">
	                                	<div class="form-group reset-link">
	                                        <label class="common-label-text"></label>
	                                        <a href="javascript: void(0)" @click="resetlink()"><i class="fa fa-angle-double-right" aria-hidden="true"></i> Send reset link</a>
	                                    </div>
	                                </div>
	                            </div>
	                        <!-- </div>
	                        <div class="row"> -->
	                            <div class="col-sm-4">
	                                <div class="form-group">
	                                	<label class="common-label-text">Email:<sup>*</sup></label>
	                                    <input v-on:keyup="emailExists()" v-model="employer.email" v-validate="'required|email'" name="email" type="text" class="form-control" placeholder="Email">
	                                    <span class="err-msg">{{ errors.first('email') }}</span>
	                                    <span class="err-msg" v-if="(!email_status && !(errors.has('email'))) && (old_email!=employer.email)">Email already exists.</span>

	                                    
	                                </div>
	                            </div>
	                            <div class="col-sm-4">
	                                <div class="form-group">
                                        <label class="common-label-text">Phone:</label>
	                                    <input v-model="employer.primary_phone" v-validate="'length:10'" name="phone number" type="number" class="form-control" placeholder="Phone">
	                                   <!-- <span class="err-msg">{{ errors.first('phone number') }}</span><sup>*</sup> -->
                                    </div>
	                            </div>
	                        </div>
	                        <!-- <div class="row">
	                            
	                        </div> -->
	                      </div>
	                    </div>
	                  </div>
	                </div>
	            </div>
	            <!-- <div class="field-group">
	                <div class="row">
	                    <div class="col-sm-12">
	                        <h3>Contact Person</h3>
	                        <div class="c-common-space c-responsive-fixwidth c-common-box-bordered c-radius3">
	                            <div class="c-common-box-shadow c-radius3 c-user-tab-content clearfix o-skillset-area">
	                                <p>Admin User(Free):</p>
	                                <div class="row">
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Contact Person Name:</label>
	                                            <input v-model="employer.cpName"type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Email:</label>
	                                            <input v-model="employer.cpEmail"type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Phone:</label>
	                                            <input v-model="employer.cpPhone" type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                    <div class="col-sm-3">
	                                        <div class="form-group ">
	                                            <label class="common-label-text">Client Access:</label>
	                                            <input v-model="employer.cpClientAccess" type="text" class="form-control" placeholder="Name">
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div> -->
	            <div class="c-common-space c-responsive-fixwidth c-radius3">
	                <div class="c-common-box-shadow c-radius3 c-user-tab-content clearfix o-skillset-area">
	                  <div class="field-group">
	                      <div class="row">
	                          <div class="col-sm-12">
	                              <div class="c-common-space c-responsive-fixwidth">
	                                  <div class="clearfix o-skillset-area">
	                                      <p>Company Address:</p>
	                                      <div class="row">
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">Street Address:</label>
	                                                  <input v-model="employer.company_address" type="text" class="form-control" placeholder="Street Address">
	                                              </div>
	                                          </div>
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">City:</label>
	                                                  <input v-model="employer.company_municipality" type="text" class="form-control" placeholder="City">
	                                              </div>
	                                          </div>
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">State:</label>
	                                                  <input v-model="employer.company_state_province" type="text" class="form-control" placeholder="State">
	                                              </div>
	                                          </div>
	                                          <div class="col-sm-3">
	                                              <div class="form-group ">
	                                                  <label class="common-label-text">Zip:</label>
	                                                  <input v-model="employer.company_postcode" type="text" class="form-control" placeholder="Zip">
	                                              </div>
	                                          </div>
	                                      </div>
	                                  </div>
	                              </div>
	                          </div>
	                      </div>
	                  </div>
	                  <div class="field-group">
	                      <div class="row">
	                          <div class="col-sm-12">

	                                  <div class="c-common-space c-responsive-fixwidth">
	                                      <div class="clearfix o-skillset-area">
	                                          <p>Company Contact:</p>
	                                          <div class="row">
												  										<div class="col-sm-3">
	                                              <div class="form-group ">
	                                                <label class="common-label-text">Company Email:</label>
	                                    						<input v-model="employer.company_email" name="company email" type="email" class="form-control" placeholder="Email">
	                                              </div>
	                                            </div>
	                                            <div class="col-sm-3">
	                                              <div class="form-group ">
																									<label class="common-label-text">Primary Phone:</label>
																									<input v-model="employer.company_primary_phone" name="phone" type="tel" class="form-control" placeholder="Primary Phone">
	                                                      <!-- <span class="err-msg">{{ errors.first('phone') }}</span><sup>*</sup> v-validate="'required'" -->
	                                              </div>
	                                            </div>
	                                            <div class="col-sm-3">
																								<div class="form-group ">
																									<label class="common-label-text">Secondary Phone:</label>
																									<input v-model="employer.company_secondary_phone" type="tel" class="form-control" placeholder="Secondary Phone">
																								</div>
																							</div>
												  
	                                              <!-- <div class="col-sm-3">
	                                                  <div class="form-group ">
	                                                      <label class="common-label-text">Cell Phone:</label>
	                                                      <input v-model="employer.company_cell_phone" type="tel" class="form-control" placeholder="Cell Phone">
	                                                  </div>
	                                              </div> -->
																							<div class="col-sm-3">
																								<div class="form-group ">
																									<label class="common-label-text">Fax:</label>
																									<input v-model="employer.company_fax" type="number" class="form-control" placeholder="Fax">
																								</div>
																							</div>
	                                          </div>
	                                      </div>
	                              </div>
	                          </div>
	                      </div>
	                  </div>
	                </div>
	              </div>
	        </div>
	        <!-- /Main Body Content area -->
	    </div>
	    <!-- /Main Content Area -->
	    <modal name="crop-image"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
		    <div class="modal-add-newJob" tabindex="-1" role="dialog">
		        <div  role="document">
		            <div class="modal-content o-common-modal-content">
		                <div class="modal-header u-no-border text-center o-small-modal-head">
		                    <button @click="closeCropModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
		                    <h4 class="modal-title">Edit Image</h4>
		                </div>
		                <div class="modal-body c-common-box-shadow o-modal-nopad-body">
		                    <div class="row">
		                        <div class="col-sm-6">
		                             <div class="c-common-space c-radius3">
		                                 <div class="c-user-tab-content clearfix o-skillset-area">
		                                     <div class="layout-table">
		                                         <div class="layout-table-cell">
		                                             <div class="employerpic-upload-sec">
		                                                 <!-- <div class="employerpic-upload"> -->
		                                                     <!-- <vue-cropper
		                                                      ref="cropper"
		                                                      :src="cropableImgPath"
		                                                      alt="Source Image"
		                                                    >
		                                                    </vue-cropper> -->
		                                                 <!-- </div> -->
		                                                 <vue-cropper
		                                                    ref="cropper"
		                                                    :guides="true"
		                                                    :view-mode="0"
		                                                    drag-mode="crop"
		                                                    :auto-crop-area="0.5"
		                                                    :min-container-width="250"
		                                                    :min-container-height="180"
		                                                    :background="true"
		                                                    :rotatable="true"
		                                                    :src="cropableImg"
		                                                    alt="Source Image"
		                                                  >
		                                                </vue-cropper>

		                                                    <!-- :img-style="{ width: '400px', height: '300px' }" -->
		                                             </div>
		                                         </div>
		                                     </div>
		                                 </div>
		                             </div>
		                        </div>
		                        <div class="col-sm-6">
		                             <div class="c-common-space c-radius3">
		                                 <div class="c-user-tab-content clearfix o-skillset-area">
		                                     <div class="layout-table">
		                                         <div class="layout-table-cell">
		                                             <div class="employerpic-upload-sec">
		                                                <div>
		                                                    <a href="javascript: void(0)" @click="cropImage()" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-crop" aria-hidden="true"></i> Crop</a>

		                                                    <a href="javascript: void(0)" @click="rotate" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-repeat" aria-hidden="true"></i> Rotate</a>
		                                                </div>
		                                                <div class="crop-image-top-margin">
		                                                    <img
		                                                      v-if="cropImg && cropImg!=''"
		                                                      :src="cropImg"
		                                                      style="width: 200px; border: 1px solid gray"
		                                                      alt="Cropped Image"
		                                                    />
		                                                </div>
		                                                
		                                                
		                                             </div>
		                                         </div>
		                                     </div>
		                                 </div>
		                            </div>
		                        </div>
		                    </div>

		                </div>
		                <div class="modal-footer text-center">
		                    <ul class="o-filter-area">
		                        <li>
		                            <a href="javascript: void(0)" @click="completeEdit()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Done</a>
		                        </li>
		                        <li>
		                            <a href="javascript: void(0)" @click="closeCropModal()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
		                        </li>
		                        
		                    </ul>
		                </div>
		            </div>
		        </div>
		    </div>
		</modal>
	</div>
</template>
<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {mapGetters, mapActions} from 'vuex';
    import service from '../../../services.js';
    import {global} from '../../../global.js';

    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';
	let timeout = null;
	
    export default {
    	components: { 
            VueCropper
        },
        data() {
            return {
            	cropImg:'',
							cropableImg:'',
							email_ckeck_flag: false,
              finalCropImg:'static/assets/images/user1.png',
            	employerDetails:[],
            	redirect_link:'',
            	email_status:'',
            	old_email:'',
            	employer:{
            		company_name:'',
            		company_email:'',
            		image:'',

            		name:'',
            		nick_name:'',
            		email:'',
            		primary_phone:'',

								company_address:'',
								company_country:'',
								company_municipality:'',
								company_postcode:'',
								company_state_province:'',

								company_primary_phone:'',
								company_secondary_phone:'',
								company_cell_phone:'',
								company_fax:'',  
								user_id: '' 	
            	},

            	image:[], 
            	loading:true,       
            	img_format:['jpg', 'jpeg', 'png', 'gif'],   
							employer_admin_user_id: ''  
            };
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                // userRole: 'userRole',
                // userClientID: 'userClientID',
            })
        },
        methods: {
        	openCropModal(){
						this.$modal.show('crop-image');
					},

					closeCropModal(){
							this.$modal.hide('crop-image');
					},

					cropImage() {
						// get image data for post processing, e.g. upload or setting image src
						this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
					},

					rotate() {
						// guess what this does :)
						this.$refs.cropper.rotate(90);
					},

					completeEdit(){
							this.finalCropImg=this.cropImg;
							this.image[0].img=this.cropImg;
							this.$modal.hide('crop-image');
							$('#imgInp').val(null);
							console.log(this.image[0]);
					},

					resetlink() {
							this.redirect_link='https://labour.'+global[0].CLIENT_BASE+'#/resetPassword';
							service.post('auth/forgotPassword', {
									redirect_link: this.redirect_link,
									email: this.employer.email,
							}, {}).then((res) => {
									if (res.data.result.status == 0) {
											this.$notify({
													title: this.$t('error'),
													message: res.data.result.message,
													type: 'error'
											});
											//console.log('incorrect');
									} else {
											// console.log('correct');
											this.$notify({
													title: this.$t('success'),
													message: this.$t('reset_password_link_sent'),
													type: 'success'
											});
									}

							}).catch((err) => {
									this.$notify({
											title: this.$t('error'),
											message: this.$t('invalid_login_credentials'),
											type: 'error'
									});
							});
					},

        	emailExists(){
						//console.log("Email Status called");
							this.email_ckeck_flag=true;
							clearTimeout(timeout);
										timeout = setTimeout(() => {
							service.get('user/emailExists', {
								'Authorization': this.userToken,
								'email':this.employer.email,
							}).
							then((res) => {
								this.email_ckeck_flag=false;
								console.log("Email Status", res.data.result);
								this.email_status=res.data.result;
								return res.data.result
							}).catch((err) => {
								this.email_ckeck_flag=false;
								console.log(err);
								return 0;
							});
						}, 1000);
					},

        	updateEmployer(){
        		this.loading=true;
        		service.put('employer/'+ atob(this.$route.params.id), this.employer, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                	this.loading=false;
                    this.$message({
                        type: 'success',
                        message: 'Employer updated successfully.'
                    });
                    // this.$router.push({
                    //     path: `/clientEmployersList`
                    // });
                    this.$router.go(-1);
                    //console.log(res);
                }).catch((err) => {
                    this.loading=false;
                    this.$message({
                        type: 'error',
                        message: 'Sorry, Something Went Wrong: Please try again later.'
                    });
                }); 
        	},

        	addProfileImg(e) {
						var input = e.target;
						// var img;
						if (input.files && input.files[0]) {
								var reader = new FileReader();
								var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
								if (input.files[0].size < 30000000 && this.img_format.indexOf(extension) != -1) {
										reader.onload = (e) => {
												// img = e.target.result;
												var type = input.files[0].type.split("/");
												this.image[0] = {
														// 'img': img,
														'name': input.files[0].name,
														'status': true,
														'uploading': false,
														'uploaded': false,
														'path': '',
														'type': type[0],
														'progress': 0,
														'label': 'Report'

												};

										}
										reader.readAsDataURL(input.files[0]);
										this.openCropModal();
										//console.log(this.image);
										//this.uploadService();
								} else {
										this.$notify.error({
												title: this.$t('error'),
												message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
										});
								}
								//this.onUpdateInputField();

						}
					},

					uploadService() {
						this.$validator.validateAll().then((result) => {
						if(result && (this.email_status || this.old_email == this.employer.email)){
							if (this.image.length != 0) {
								this.loading=true;
											service.post('attachment/uploadSingleFile', {
														'image_file': this.image[0].img,
														'file_name': this.image[0].name
												}, {
														'Authorization': this.userToken,
												})
												.then((res) => {
														this.employer.image=res.data.result.path;

														this.image[0].path = res.data.result.path;
														this.image[0].uploaded = true;
														//console.log('RESPONSONE', res);
														
														this.updateEmployer();
												}).catch((err) => {
														console.log(err);
														this.updateEmployer();
												});
									} else {
											this.updateEmployer();
									}	
							
						}else{
							this.$notify.error({
													title: this.$t('error'),
													message: 'Please fill in all required fields marked with an asterisk.'
											});	
						}

					});
					},

					getEmployerDetais(){
						//this.$Progress.start();
							this.loading=true;
							service.get('employer/' + atob(this.$route.params.id), {
									'Authorization': this.userToken,
							}).
							then((res) => {
							this.loading=false;
							this.employerDetails = res.data.result;
							// console.log(this.employerDetails);
							this.employer.company_name=this.employerDetails.name;
							this.employer.company_email=this.employerDetails.email;
							this.employer.image=this.employerDetails.image;
							this.finalCropImg=(this.employerDetails && this.employerDetails.image && this.employerDetails.image!='')? this.employerDetails.image:'static/assets/images/user1.png';
							for( let i=0; i<this.employerDetails.employer_users.length; i++){
								if(this.employerDetails.employer_users[i].user.role.slug=='employer-admin'){
									this.employer.name=this.employerDetails.employer_users[i].user.first_name;
									this.employer.nick_name=this.employerDetails.employer_users[i].user.display_name;
									this.employer.email=this.employerDetails.employer_users[i].user.email;
									this.old_email=this.employerDetails.employer_users[i].user.email;
									this.employer.user_id = this.employerDetails.employer_users[i].user_id;
									
									let key;
									for(key in this.employerDetails.employer_users[i].user.phones)
										{	//console.log(key, this.employerDetails.employer_users[0].user.phones[key].phone_number);
											if(this.employerDetails.employer_users[i].user.phones[key].phone_number){
												if(this.employerDetails.employer_users[i].user.phones[key].label=='Primary phone'){
													this.employer.primary_phone=this.employerDetails.employer_users[i].user.phones[key].phone_number;
												}
											}
										}
								}
							}

							for(let key in this.employerDetails.phones)
							{
					//  console.log(this.employerDetails.phones[key].label);
								if(this.employerDetails.phones[key].phone_number){
									switch(this.employerDetails.phones[key].label){
										case 'Primary phone':
											this.employer.company_primary_phone=this.employerDetails.phones[key].phone_number;
											break;
										case 'Secondary phone':
											this.employer.company_secondary_phone=this.employerDetails.phones[key].phone_number;
											break;
										case 'Cell phone':
											this.employer.company_cell_phone=this.employerDetails.phones[key].phone_number;
											break;
										case 'Fax':
											this.employer.company_fax=this.employerDetails.phones[key].phone_number;
											break;
										default:
											// console.log('label not found');

									}
								}	
							}
							if(this.employerDetails.addresses && this.employerDetails.addresses.length>0){
									this.employer.company_address=this.employerDetails.addresses[0].address;
								this.employer.company_country=this.employerDetails.addresses[0].country;
								this.employer.company_municipality=this.employerDetails.addresses[0].municipality;
								this.employer.company_postcode=this.employerDetails.addresses[0].postcode;
								this.employer.company_state_province=this.employerDetails.addresses[0].state_province;	
								}
							
								}).catch((err) => {
										console.log(err);
										this.loading=false;
								});
						}
       	},
        mounted() {
        	let self=this;
            $(document).on('change', '.btn-file :file', function() {
                var input = $(this),
                    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
                input.trigger('fileselect', [label]);
            });

            $('.btn-file :file').on('fileselect', function(event, label) {
                var input = $(this).parents('.input-group').find(':text'),
                    log = label;
                if (input.length) {
                    input.val(log);
                } else {
                    if (log) alert(log);
                }
            });

            function readURL(input) {

                var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
                if (input.files && input.files[0] && input.files[0].size < 30000000 && self.img_format.indexOf(extension) != -1) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        // $('#img-upload').attr('src', '');
                        self.cropImg='';
                        self.cropableImg=e.target.result;
                        self.$refs.cropper.replace(e.target.result);

                        var type = input.files[0].type.split("/");
                        self.image[0] = {
                            // 'img': img,
                            'name': input.files[0].name,
                            'status': true,
                            'uploading': false,
                            'uploaded': false,
                            'path': '',
                            'type': type[0],
                            'progress': 0,
                            'label': 'Report'
                        };

                        setTimeout(()=>{
                            self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();
                        },1000)
                    }
                    reader.readAsDataURL(input.files[0]);
                }else {
                    self.$notify.error({
                        title: this.$t('error'),
                        message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
                    });
                }
                
                // self.onUpdateInputField();
            }

            $("#imgInp").change(function() {
                readURL(this);
            });
        },
        created() {
            this.getEmployerDetais();
        }
    }

</script>
<style scoped>
sup {
	color: red;
}

.crop-image-top-margin{
    margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/superAdmin/employers/editEmployerClient.vue